'use client';
import { useRouter } from 'next/navigation';
import styles from './Pagination-Style2.module.css';
import { FaArrowLeftLong, FaArrowRightLong } from 'react-icons/fa6';

interface PaginationProps {
    pageCount: number;
    baseUrl: string;
    currentPage: number;
}

export default function Pagination({ pageCount, baseUrl, currentPage }: PaginationProps) {
    const router = useRouter();

    const getPageLink = (page: number) => {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('page', page.toString());
        return url.pathname + url.search;
    };

    const handleClick = (page: number) => {
        router.push(getPageLink(page));
    };

    const paginationItems = () => {
        const pages = [];

        if (pageCount <= 7) {
            for (let i = 1; i <= pageCount; i++) {
                pages.push(
                    <li key={i} className={`${styles.NavItem} ${i === currentPage ? styles.ActiveItem : ''}`} onClick={() => handleClick(i)}>
                        {i}
                    </li>
                );
            }
        } else {
            pages.push(
                <li key={1} className={`${styles.NavItem} ${1 === currentPage ? styles.ActiveItem : ''}`} onClick={() => handleClick(1)}>
                    1
                </li>
            );

            let start = 2;
            let end = 5;

            if (currentPage > 4) {
                pages.push(
                    <li key="left-ellipsis" className={styles.ellipsis}>
                        ...
                    </li>
                );
                start = currentPage - 2;
                end = currentPage + 2;
            }

            if (currentPage > pageCount - 4) {
                start = pageCount - 4;
                end = pageCount - 1;
            }

            for (let i = start; i <= end; i++) {
                pages.push(
                    <li key={i} className={`${styles.NavItem} ${i === currentPage ? styles.ActiveItem : ''}`} onClick={() => handleClick(i)}>
                        {i}
                    </li>
                );
            }

            if (currentPage < pageCount - 3) {
                pages.push(
                    <li key="right-ellipsis" className={styles.ellipsis}>
                        ...
                    </li>
                );
            }

            pages.push(
                <li key={pageCount} className={`${styles.NavItem} ${pageCount === currentPage ? styles.ActiveItem : ''}`} onClick={() => handleClick(pageCount)}>
                    {pageCount}
                </li>
            );
        }

        return pages;
    };

    return (
        <ul className={styles.PaginationWrap}>
            <li
                //prettier-ignore
                className={`${styles.Prev} ${currentPage <= 1 ? styles.Disabled : ''}`}
                onClick={() => handleClick(currentPage > 1 ? currentPage - 1 : 1)}
            >
                <FaArrowLeftLong />
            </li>
            {paginationItems()}
            <li
                //prettier-ignore
                className={`${styles.Next} ${currentPage >= pageCount ? styles.Disabled : ''}`}
                onClick={() => handleClick(currentPage < pageCount ? currentPage + 1 : pageCount)}
            >
                <FaArrowRightLong />
            </li>
        </ul>
    );
}
